import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { LocaleLink } from "../../i18n/LocaleLink";
import { useLocalizedPath, isActivePath } from "../../i18n/useLocalizedPath";

export const NavMenus = () => {
  const { t } = useTranslation();
  const path = useLocalizedPath();

  const isActiveCn = (route) => (isActivePath(path, route) ? "active" : "");

  return (
    <div className="navbar-wrap main-menu d-none d-lg-flex">
      <ul className="navigation">
        <li className={cn(isActiveCn("/"))}>
          <LocaleLink to="/">{t("nav.home")}</LocaleLink>
        </li>
        <li className={cn(isActiveCn("/about"))}>
          <LocaleLink to="/about">{t("nav.about")}</LocaleLink>
        </li>
        <li className={cn(isActiveCn("/services"))}>
          <LocaleLink to="/services">{t("nav.services")}</LocaleLink>
        </li>
        <li className={cn(isActiveCn("/blog"))}>
          <LocaleLink to="/blog">{t("nav.blog")}</LocaleLink>
        </li>
        <li className={cn(isActiveCn("/contact"))}>
          <LocaleLink to="/contact">{t("nav.contact")}</LocaleLink>
        </li>
      </ul>
    </div>
  );
};
